import React from "react"
import Button from "../../Button"
import { FormContext } from "../Form"

const Submit = ({ children, ...props }) => {

  return <FormContext.Consumer>
    {({ negative }) => <Button className="w-fit" negative={negative} type="submit" {...props}>{children}</Button>}
  </FormContext.Consumer>
}

export default Submit